import { Injectable, ViewChild } from '@angular/core';
// import { Events, Content } from "@ionic/angular";
import { Song } from '../data/Song';
import { FirestoreService } from './FirestoreService';
// import { AudioService } from './AudioService';
import { AuthService } from './AuthService';
import { BehaviorSubject, Subject } from 'rxjs';
import { AudioService } from './AudioService';
import { SongPlayingService } from './songPlayingService';

declare var $: any;

@Injectable()
export class ModelService {
  showModel: boolean;
  // @ViewChild('pageTop') pageTop: Content;
  rngNum: any = 0;
  loadedSongs = false;
  pause: boolean = true;
  // pause$: Subject<boolean> = this.audioService.pause$['value'];
  blur: boolean = false;
  song: any = {};
  songs: Song[] = [];
  song$: Subject<Song[]> = new BehaviorSubject([]);
  recentArray: any[] = [];
  tracks: any[] = [];
  userId: string;
  count: number = 2;
  duration: number;
  constructor(
    // public events: Events,
    private audioService: AudioService,
    private firestoreService: FirestoreService,
    private authService: AuthService,
    // private songPlayingService: SongPlayingService
  ) {
    // this.getSongs();
    this.authService.afAuth.user.subscribe((user) => {
      if (user) {
        this.userId = user.uid;
        // this.getUserName.subscribe(name => console.log('name', name));
      }
    });
    // this.events.publish('pause', false);
  }
  calle() {
    // console.log('rnage numb', this.rngNum);
    setTimeout(() => {
      this.timer();
    }, 2000);
  }
  /**
   * Method to scroll to top
   */

  playonLoop() {
    // this.audioService.repeat();
    // console.log('home', HomePage.loop);
    // HomePage.loop = !HomePage.loop;
  }

  playPause() {
    if (this.audioService.pause$['value']) {
      this.audioService.play();
      this.pause = false;
      // this.audioService.pause$.next(false);

    } else {
      this.audioService.pause();
      this.pause= true;
      // this.audioService.pause$.next(true);


    }

  }

  playSong(trackIndex: number) {
   
    if (trackIndex == undefined) return;
    // console.log(this.tracks, trackIndex);
    if (this.audioService.setTracksAndPlay(this.tracks, trackIndex)) {
      this.audioService.pause$.next(false);
      this.pause = false;
      // this.song = this.songs[trackIndex];
      // this.duration = this.song.duration;
      // this.firestoreService.setSongPlayingDuration(false);
      // if (this.recentArray[this.recentArray.length - 1] != trackIndex)
      //   this.recentArray.push(trackIndex);
      // this.firestoreService.addSongToRecentlyPlayed(
      //   this.userId,
      //   this.songs[trackIndex]
      // );
      // this.updateSongIsPlaying();
    }
  }

  recentTracks(tracks, trackIndex) {
    this.tracks = [];
    this.song = tracks;
          this.songs.forEach((song) => {
        var track = {
          src: song.songUrl,
          artist: song.artistName,
          title: song.name,
          art: song.albumPicture,
          preload: 'metadata', // tell the plugin to preload metadata such as duration for this track, set to 'none' to turn off
          songId: song.songId,
          artistId: song.artistId,
          // duration: roundedLength,
          albumId: song.albumId,
        };

        this.tracks.push(track);
        // $("#duration").textContent = length;
      });
    console.log('recent track list',this.tracks);
    if (trackIndex == undefined) return;
    // console.log(this.tracks, trackIndex);
    setTimeout(() => {
      if (this.audioService.setTracksAndPlay(this.tracks, trackIndex)) {

        this.song = this.songs[trackIndex];
    }
      }, 1000);
  }

  playSongByAlbum(trackId, trackIndex: number) {
    this.tracks = [];
    this.getAlbumSongs(trackId).then(val => {
        if (trackIndex == undefined) return;
    // console.log(this.tracks, trackIndex);
      setTimeout(() => {
        if (this.audioService.setTracksAndPlay(this.tracks, trackIndex)) {
      // this.audioService.pause$.next(false);

      this.song = this.songs[trackIndex];
      // this.duration = this.song.duration;
      // this.firestoreService.setSongPlayingDuration(false);
      // if (this.recentArray[this.recentArray.length - 1] != trackIndex)
      //   this.recentArray.push(trackIndex);
      // this.firestoreService.addSongToRecentlyPlayed(
      //   this.userId,
      //   this.songs[trackIndex]
      // );
      // this.updateSongIsPlaying();
    }
      }, 1000);
    
    })
  
  }

  getDuration(src) {
    return new Promise(function (resolve) {
      var audio = new Audio();
      $(audio).on('loadedmetadata', function () {
        resolve(audio.duration);
      });
      audio.src = src;
    });
  }

  getAlbumSongs(id?: any) {
    return new Promise((resolve) => {
      this.firestoreService.getAlbumSongs(id).then((result: any) => {
      this.songs = result.songs;


      // console.log('rounded', len);
      var song = this.songs.map((el: any) => {
        var o = Object.assign({}, el);
        this.getDuration(el.songUrl).then(function (length: number) {
          // console.log('I got length ', length);
          // var roundedLength = Math.round(length / 60);
          o.duration = length;
        });
        return o;
      });
      this.songs = song;

      this.songs.forEach((song) => {
        var track = {
          src: song.songUrl,
          artist: song.artistName,
          title: song.name,
          art: song.albumPicture,
          preload: 'metadata', // tell the plugin to preload metadata such as duration for this track, set to 'none' to turn off
          songId: song.songId,
          artistId: song.artistId,
          // duration: roundedLength,
          albumId: song.albumId,
        };
        this.tracks.push(track);
        console.log('tracks array', this.tracks);
        resolve(this.tracks);
        // $("#duration").textContent = length;
      });
      // this.song$.next(this.songs);
      // console.log('songs', this.songs);

      this.loadedSongs = true;
      this.updateSongIsPlaying();
    });  
    })
  
  }

    getSongs() {
    this.firestoreService.getSongs().then((result: any) => {
      this.songs = result.songs;


      // console.log('rounded', len);
      var song = this.songs.map((el: any) => {
        var o = Object.assign({}, el);
        this.getDuration(el.songUrl).then(function (length: number) {
          // console.log('I got length ', length);
          // var roundedLength = Math.round(length / 60);
          o.duration = length;
        });
        return o;
      });
      this.songs = song;

      this.songs.forEach((song) => {
        var track = {
          src: song.songUrl,
          artist: song.artistName,
          title: song.name,
          art: song.albumPicture,
          preload: 'metadata', // tell the plugin to preload metadata such as duration for this track, set to 'none' to turn off
          songId: song.songId,
          artistId: song.artistId,
          // duration: roundedLength,
          albumId: song.albumId,
        };

        this.tracks.push(track);
        // $("#duration").textContent = length;
      });
      this.song$.next(this.songs);
      // console.log('songs', this.songs);

      this.loadedSongs = true;
      this.updateSongIsPlaying();
    });
  }



  updateSongIsPlaying() {
    // if (this.loadedSongs && this.audioService.playingTrack() !== undefined) {
    //   this.songs.forEach((song) => {
    //     if (song.songId == this.audioService.playingTrack().songId) {
    //       song.isPlaying = true;
    //     } else {
    //       song.isPlaying = false;

    //     }
    //   });
    // }
  }

  timer() {
    this.blur = !this.blur;
  }

  recentSong() {
    console.log('recent clicked');
    // this.notBack = true;
    // this.firestoreService.getRecentlyPlayed(this.userId)
    //   .then((res) => {
    //     console.log({ res });
    // var index = this.songs.map(function (song) { return song.songId; }).indexOf(res['recentlyPlayed'][1].songId);
    // setTimeout(() => {

    // this.playSong(this.recentArray[this.recentArray.length - this.count]);
    // if (this.recentArray.length > 2) {
    //   this.recentArray.pop();
    //   this.count++;
    // }
    // console.log(
    //   'recent songs',
    //   this.count,
    //   this.recentArray,
    //   this.recentArray[this.recentArray.length - this.count]
    // );
  }
}
